import { Event } from "event-system";
import { IFigureModelFactory } from "../../factories/figures/IFigureModelFactory";
import { IFigureModel } from "../figure/IFigureModel";
import { inject, injectable } from "@launchtray/tsyringe-async";
import { InjectableModelFactories } from "../../../../composition/InjectableModelFactories";

@injectable()
export class DeckModel {
    public onSelectFigure: Event<void>;
    private readonly deckSize: number;
    public readonly deck: Array<IFigureModel>;
    private selectedFigureIndex: number;
    private isSpecialSlotActive: boolean;
    public readonly onChanged: Event;
    public readonly onChangedSpecialSlot: Event;

    public constructor(
        @inject(InjectableModelFactories.IFigureModelFactory) private readonly figureFactory: IFigureModelFactory,
    ) {
        this.deckSize = 4;
        this.deck = new Array<IFigureModel>(this.deckSize);
        this.onSelectFigure = new Event<void>();
        this.onChanged = new Event();
        this.onChangedSpecialSlot = new Event();
        for (let i = 0; i < this.deckSize - 1; i++) {
            this.deck[i] = figureFactory.createRandomFigure();
        }
        this.isSpecialSlotActive = false;
    }

    public createSpecialFigure(): void {
        this.deck[this.deckSize - 1] = this.figureFactory.createSpecialSlotFigure();
        this.isSpecialSlotActive = true;
        this.onChangedSpecialSlot.emit();
    }

    public removeSpecialFigure(): void {
        this.deck[this.deckSize - 1] = null;
        this.isSpecialSlotActive = false;
        this.onChangedSpecialSlot.emit();
    }

    public removeSelectedFigureFromDeck(): void {
        if (this.selectedFigureIndex == null) {
            return;
        }
        if (this.selectedFigureIndex == this.deckSize - 1) {
            this.isSpecialSlotActive = false;
            this.onChangedSpecialSlot.emit();
        }
        this.deck[this.selectedFigureIndex] = null;
        this.updateDeckStatus();
    }

    private updateDeckStatus(): void {
        for (let i = 0; i < this.deckSize - 1; i++) {
            if (this.deck[i] != null) {
                return;
            }
        }
        this.shuffle();
        this.onChanged.emit();
    }

    public shuffle(): void {
        for (let i = 0; i < this.deckSize - 1; i++) {
            this.deck[i] = this.figureFactory.createRandomFigure();
        }
        this.onChanged.emit();
    }

    public set SelectedFigureIndex(index: number) {
        if (index < 0 || index > this.deck.length - 1) {
            return;
        }
        this.selectedFigureIndex = index;
        this.onSelectFigure.emit();
    }

    public get SelectedFigureIndex(): number | null {
        return this.selectedFigureIndex;
    }

    public get IsSpecialSlotActive(): boolean {
        return this.isSpecialSlotActive;
    }
}